<div class="app-shell relative" id="canvas-bookmark">
  <app-header></app-header>
  <div class="bg-[#f8f8f8]">
    <div
      [class.sidebar-rail]="navServices.collapseSidebar"
      class="fixed top-0 z-9 h-auto w-[280px] bg-(--sidebar-background-light) text-left leading-[inherit] shadow-[0_0_21px_0_rgba(89,102,122,0.1)] transition-all duration-300 ease-css collapsed-root:w-auto collapsed-root:max-lg:[transform:translate(-285px)]"
    >
      <app-sidebar></app-sidebar>
    </div>
    <div
      class="app-content relative mt-20 ml-[280px] min-h-[calc(100vh-80px)] px-[15px] transition-all duration-500 ease-css sibling-collapsed:ml-[92px] max-lg:mt-[63px] max-lg:ml-0! max-sm:mt-[60px] max-sm:p-0!"
    >
      <main (click)="closeSidebar()">
        <router-outlet (activate)="activateEvents($event)"></router-outlet>
      </main>
    </div>
    <footer
      class="ml-[280px] bg-white p-[15px] shadow-[0_0_20px_rgba(89,102,122,0.1)] transition-all duration-500 ease-css sibling-collapsed:ml-[92px] max-lg:ml-0! max-[360px]:pr-0! max-[360px]:pl-0 max-[360px]:[&_p]:text-[12px]"
    >
      <app-timer-display></app-timer-display>
    </footer>
  </div>
</div>
